import React from "react";

// Mobile-only top bar with a hamburger drawer (Home / About / Contact),
// plus the horizontal company tab strip that only shows on the home page.
// Visibility below 580px is handled entirely by Portfolio2026.scss.
function MobileHeader({
  page,
  companies,
  activeCompany,
  drawerOpen,
  onToggleDrawer,
  onNavigate,
  onCompanyClick,
}) {
  return (
    <>
      <div className="mob-bar" id="mob-bar">
        <div className="mob-bar-name" onClick={() => onNavigate("home")}>
          Brann Khattiyanont
        </div>
        <button className="mob-bar-ham" onClick={onToggleDrawer}>
          ≡
        </button>
      </div>

      <div id="mob-drawer" className={drawerOpen ? "" : "hide"}>
        <div
          className={"mob-drawer-item" + (page === "home" ? " active" : "")}
          onClick={() => onNavigate("home")}
        >
          Home
        </div>
        <div className="mob-drawer-sep" />
        <div
          className={"mob-drawer-item" + (page === "about" ? " active" : "")}
          onClick={() => onNavigate("about")}
        >
          About me
        </div>
        <div
          className={"mob-drawer-item" + (page === "contact" ? " active" : "")}
        >
          <a
            className="sb-ext-link"
            href="/BrannKhattiyanont_Resume.pdf"
            target="_blank"
          >
            Resume ↓
          </a>
        </div>
        <div
          className={"sb-nav-link" + (page === "about" ? " active" : "")}
        ></div>
      </div>

      <div
        className={"mob-co-strip" + (page !== "home" ? " hide" : "")}
        id="mob-co-strip"
      >
        <div className="mob-co-inner" id="mob-tabs">
          {companies.map((co, ci) => (
            <button
              key={co.id}
              className={"mctab" + (ci === activeCompany ? " act" : "")}
              onClick={() => onCompanyClick(ci)}
            >
              {co.name}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}

export default MobileHeader;
